import { createTheme } from "@mui/material/styles";

// Dark mode, from the "Scenes Redesign" design: the choice is kept in localStorage and shown as
// data-vvt="dark" on <html>, which the page stylesheets key their dark tokens off. Only pages built
// on the design tokens (UserBar `themed`) turn it on; the others stay light.

const KEY = "theme";

export function isDark() {
  try {
    return localStorage.getItem(KEY) === "dark";
  } catch (e) {
    return false;
  }
}

export function saveDark(dark) {
  try {
    localStorage.setItem(KEY, dark ? "dark" : "light");
  } catch (e) {}
}

// App listens for "theme-change" to switch the MUI theme (menus, dialogs, inputs)
export function applyTheme(dark) {
  const root = document.documentElement;
  if ((root.getAttribute("data-vvt") === "dark") === dark) return;
  root.setAttribute("data-vvt", dark ? "dark" : "light");
  window.dispatchEvent(new CustomEvent("theme-change", { detail: dark }));
}

export const lightTheme = createTheme();

// the design's dark palette (--p-accent, --p-bg, --p-surface, --p-ink, --p-muted, --p-line)
export const darkTheme = createTheme({
  palette: {
    mode: "dark",
    primary: { main: "#86b4ff" },
    background: { default: "#0d141e", paper: "#151f2c" },
    text: { primary: "#e4ecf7", secondary: "#8fa3bd" },
    divider: "#2a3a4f",
  },
  components: {
    // flat surfaces as in the design (MUI lightens raised dark paper)
    MuiPaper: { styleOverrides: { root: { backgroundImage: "none" } } },
  },
});
